import { render, staticRenderFns } from "./WebsiteFooter.vue?vue&type=template&id=677eda1c&"
import script from "./WebsiteFooter.vue?vue&type=script&lang=js&"
export * from "./WebsiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports